export default {
  panelsInfo: [],
  showSidebar: false,
  showEditPanel: false,
  panel: {},
  idPanel: null,
  loading: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/panels/initialState.js